<template>
  <v-row>
    <v-col cols="12">
      <v-card class="mx-auto" outlined>
        <v-list-item three-line>
          <v-list-item-content>
            <div class="text-h5 mb-3">
              <span class="ml-3">Olá {{ user.nome }}!</span>
            </div>
            <v-col cols="auto">
              <p>
                Utilize os menus superiores para selecionar a página que deseja
                acessar. As opções que aparecem para você estão configuradas de
                acordo com suas permissões, vínculos e alocações. Caso não
                encontre o que esteja precisando ou esbarre em algum erro por
                aí, contate os administradores pelo chat
                <strong>
                  <a
                    href="http://chat.educacao.itajai.sc.gov.br/index.php/por/chat/startchat/(leaveamessage)/true/(theme)/1/(department)/4?prefill[username]=&value_items_admin[0]=&prefill[email]="
                    :onclick="
                      `window.open(this.href, 'erudio','width=550,height=500'); return false;`
                    "
                  >
                    clicando aqui!
                  </a>
                </strong>
              </p>
            </v-col>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
// import FormSubtitle from "@/components/Snackbar";
import { getUser } from "@/plugins/security";

export default {
  name: "App",

  components: {},

  data: () => ({
    user: getUser()
  }),
  methods: {
    getUser
  }
};
</script>
